import { useMap } from "maplibre-react-components";
import { LngLatBoundsLike, LngLatLike } from "maplibre-gl";
import { useAtomValue } from "jotai";
import { mapProjectionAtom } from "@/store";

export const useMapLibre = () => {
  const map = useMap("map");
  const projection = useAtomValue(mapProjectionAtom);

  const flyTo = (position: LngLatLike): void => {
    if (map) map.flyTo({ center: position, essential: true });
  };

  const fitBounds = (bounds: LngLatBoundsLike): void => {
    if (map) map.fitBounds(bounds);
  };

  return {
    map,
    projection,
    flyTo,
    fitBounds,
  };
};
